import React, { useContext } from 'react';
import { DropdownContext } from './DropdownContext.es.js';
import { styled } from '@teko/ds-desktop';
import { Popper } from '../Popper/Popper.es.js';

const StyledDiv = styled.div(({ show }) => `
    background-color: transparent;
    opacity: ${show ? 1 : 0};
  `);
const StyledPopper = styled(Popper)(({ show }) => `
    visibility: ${show ? "visible" : "hidden"};
    z-index: 999;
  `);
const DropdownMenu = ({
  children,
  popperConfig,
  placement = "bottom-start",
  origin = "center top",
  className
}) => {
  const {
    state: { isOpen, referenceElement }
  } = useContext(DropdownContext);
  return /* @__PURE__ */ React.createElement(StyledPopper, {
    className,
    referenceElement,
    popperConfig,
    placement,
    show: isOpen
  }, /* @__PURE__ */ React.createElement(StyledDiv, {
    show: isOpen,
    origin
  }, children));
};

export { DropdownMenu };
